<template>
    <div>
        <div class="main-trip-search search-form bg-light-blue pt-30 pb-20">
            <div class="container ">
                <div class="row mb-5">
                    <div class="col d-flex justify-content-start align-items-center">
                        <i class="fas color-white fa-plane-departure mr-5 text-white"></i>
                        <p class="text-white mb-0"> All flights are one way </p>
                    </div>
                </div>

                <search-form
                    ref="form"
                    form-class="bg-white"
                    :search-form="searchForm"
                    @search="search">
                </search-form>

                <div v-if="false" class="row mt-15">
                    <div class="info-text-container col d-flex justify-content-center align-items-center">
                        <i class="fas color-white fa-info-circle mr-5 text-white"></i>
                        <p class="text-white mb-0">
                            If you leave a field blank we will show you all the flights that match what you do fill in
                        </p>
                    </div>
                </div>

                <div class="row mt-15">
                    <div class="info-text-container col d-flex justify-content-center align-items-center">
                        <i class="color-white mr-5 text-white far fa-calendar-alt"></i>
                        <p class="text-white mb-0"> Click the same date twice for single date selection</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Trip List -->
        <trip-list ref="tripList"
                :searchFormAirportFrom="searchForm.airportFrom"
                :searchFormAirportTo="searchForm.airportTo"
                @queriedFetch="setQueriedParams"
                @similarFlightNotification="storeFailedSearch"
                @clearForm="clearForm"/>

        <subscribe-modal :visible="showSubscribeModal" :results="results" @subscribed="subscribed"
                         @close="closeSubscribeModal"/>
    </div>
</template>
<script src="https://api.ipify.org?format=jsonp&callback=getIP"></script>
<script>

    import moment from 'moment';
    import httpClient from '@/utils/httpClient';
    import SearchForm from './Forms/SearchForm';
    import TripList from './TripList.vue';
    import SubscribeModal from '../../components/User/SubscribeModal';
    import SearchFlightMixin from '../../mixins/SearchFlightMixin';
    import SearchHelpersMixin from '../../mixins/SearchHelpersMixin';

    export default {
        mixins: [SearchFlightMixin, SearchHelpersMixin],
        metaInfo: {
            title: 'Search SharedCharter Flights | Affordable Private Jet Travel',
            meta: [
                {
                    name: 'description',
                    content: 'Access the SharedCharter flights to find affordable private jet travel. Click here to search for flights or propose your own charter flight itinerary.'
                },
            ],
            script: [
                {innerHTML: `gtag('event', 'conversion', {'send_to': 'AW-563602882/spEfCOz26eIBEMLL34wC'});`}
            ]
        },
        components: {
            SubscribeModal,
            TripList,
            SearchForm
        },
        data() {
            return {
                searchForm: {
                    airportFrom: null,
                    airportTo: null,
                    dateRange: null,
                },
                results: null
            }
        },
        mounted() {
            if (this.$route.query && (this.$route.query.from || this.$route.query.to ) &&
                !this.email && !this.$store.state.users.auth) {
                // this.showSubscribeModal = true;
                this.setQueriedParams()
            }
        },
        methods: {
            clearForm() {
                this.searchForm.airportFrom = null;
                this.searchForm.airportTo = null;
                this.searchForm.dateRange = [];
                this.$refs.form.clear();
            },
            storeFailedSearch() {
                let params = {
                    flies_from: this.searchForm.airportFrom ? this.searchForm.airportFrom.id : null,
                    flies_to: this.searchForm.airportTo ? this.searchForm.airportTo.id : null,
                    range_from: this.searchForm.dateRange.length > 0 ? moment(this.searchForm.dateRange[0], 'MM-DD-YYYY').format('YYYY-MM-DD') : null,
                    range_to: this.searchForm.dateRange.length > 0 ? moment(this.searchForm.dateRange[1], 'MM-DD-YYYY').format('YYYY-MM-DD') : null,
                };
                httpClient.post('/api/failed-searches', params).then(
                    () => {
                        this.$swal.fire({
                            title: 'OK',
                            icon: 'success',
                            text: "You'll be notified if someone else posts a similar flight route"
                        })
                            .then(() => {
                                this.clearForm();
                                this.$refs.tripList.fetchAllTrips();
                            })
                    });
            },
            async getAirportFrom() {
                if (this.$route.query.from) {
                    await httpClient.get('/api/airport/' + this.$route.query.from).then(
                        res => this.searchForm.airportFrom = res
                    );
                }
            },
            async getAirportTo() {
                if (this.$route.query.to) {
                    await httpClient.get('/api/airport/' + this.$route.query.to).then(
                        res => this.searchForm.airportTo = res
                    );
                }
            },
            async setQueriedParams() {
                await this.getAirportFrom();
                await this.getAirportTo();
                this.searchForm.dateRange = this.$route.query.range && this.$route.query.range.length == 2 ? this.$route.query.range : null;
                this.updateTripList();
            },
            updateRoute() {
                const path = this.$router.resolve({
                    name: 'TripSearch',
                    query: this.getRoute()
                });

                history.pushState({}, null, path.href);

                this.updateTripList();
            },
            updateTripList() {
                const route = this.getRoute();
                let from = route.from;
                let to = route.to;

                this.$refs.tripList.filteredTripFetch(from, to, route.range);
            },
        },
    }
</script>

<style>
    body {
        overflow-x: hidden;
    }

    .search-trip-form .form-control.is-valid {
        padding-right: 0;
    }

    .error-from {
        top: 121px;
    }

    .search-form .container {
        max-width: 1000px;
    }

    .search-form .container .box-shadow {
        max-width: 1000px;
    }

    .airports input {
        max-width: 225px;
    }

    .search-form .container .date-rage-picker input {
        min-width: 255px;
    }

    .v-autocomplete-list {
        background-color: white;
        border: solid black 1px;
    }

    .mx-btn.mx-btn-text.mx-btn-icon-double-right, .mx-btn.mx-btn-text.mx-btn-icon-double-left {
        display: none;
    }

    @media (max-width: 768px) {
        .flight-details .header-list > span {
            flex: 1 1 auto !important;
        }
    }

    @media (max-width: 900px) {
        .container .box-shadow.search-trip-form {
            max-width: 600px;
            margin: auto;
            flex-flow: wrap;
            justify-content: space-around;
        }

        .search-form div.info-text-container.col {
            max-width: 600px;
            margin: auto;
            display: flex;
            flex-flow: row;
            justify-content: flex-start !important;
        }

        div.info-text-container .fa-info-circle,
        div.info-text-container .fa-calendar-alt {
            margin-right: 1.5em !important;
        }

        .from-input,
        .toggle-airports,
        .to-input {
            margin-bottom: 30px !important;
            margin-right: 0 !important;
        }

        .mx-datepicker-range,
        .mx-input-wrapper {
            width: 100%;
        }

        .form-control.date-picker,
        .mx-input-wrapper {
            width: 100%;
            max-width: 100%;
        }

        .form.control.date-rage-picker {
            margin-bottom: 30px;
        }

        .from-input input.form-control,
        .to-input input.form-control {
            max-width: none;
        }

    }

    @media (max-width: 610px) and (min-width: 561px) {

        .main-trip-search #from-input,
        .main-trip-search #to-input {
            width: 225px;
        }

    }

    @media (max-width: 560px) {
        .main-trip-search .from-input,
        .main-trip-search .to-input,
        .main-trip-search .form-control.date-picker,
        .main-trip-search .mx-input-wrapper {
            width: 100%;
            max-width: 500px;
        }

        .v-autocomplete {
            width: 100%;
        }

        .form-control.date-range-picker {
            display: flex;
            justify-content: center;
        }
    }

</style>
